// src/App.js
import React from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import AppContent from "./AppContent"; // Importing AppContent
import "./App.css";

function App() {
  return (
    <ErrorBoundary>
      <AppContent />
    </ErrorBoundary>
  );
}

export default App;

